import ClpFlagIcon from '../assets/icons/flags/ClpFlagIcon';
import UsaFlagIcon from '../assets/icons/flags/UsaFlagIcon';

const CURRENCY_FLAGS = {
  CLP: ClpFlagIcon,
  USD: UsaFlagIcon,
};

export default CURRENCY_FLAGS;
